import api from '../../../App/socket';

export const updateBikeProfile = (leadId, data) => (
    api.send({
        api: 'db',
        model: 'Bike_lead',
        action: 'Update',
        options: {
            where: { _id: leadId },
            update: data,
        },
    }).then((response) => {
        return response;
    }).catch(error => error)
);

export const changeBikeProfile = (_id, key, value) => (
    api.send({
        api: 'db',
        model: key === 'model_variation' ? 'Bike_model' : 'Bike_lead',
        action: 'Update',
        options: {
            where: { _id },
            update: typeof key === 'object' ? key : { [key]: value },
        },
    }).then((response) => {
        return response;
    }).catch(error => error)
);

// model_variation is not editable field, 'Bike_model' update is not used
export const changeLeadProfile = (_id, key, value) => (
    api.send({
        api: 'db',
        model: key === 'model_variation' ? 'Bike_model' : 'Bike_lead',
        action: 'Update',
        options: {
            where: { _id },
            update: typeof key === 'object' ? key : { [key]: value },
        },
    }).then((response) => {
        return response;
    }).catch(error => error)
);

export const changeLeadCustomer = (_id, key, value) => (
    api.send({
        api: 'db',
        model: 'Lead_customer',
        action: 'Update',
        options: {
            where: { _id },
            update: (key !== 'city' && key !== 'county' && key !== 'street' && key !== 'post_code' && key !== 'country')
                ? { [key]: value }
                : value instanceof Object
                    ? value : { [`address.${key}`]: value },
        },
    }).then(response => response).catch(error => error)
);

export const updateLeadHistory = ({ leadId, action }) => {
    api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'UpdateLeadHistory',
        options: {
            leadId,
            action,
        },
    }).then(response => response).catch(error => error)
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/change_lead_profile_request.js